<div class="flex flex-shrink-0 w-16 print:hidden !h-full">
  <nav class="flex flex-col items-center text-textpbg-700 bg-pbg-600">
    <slot />
  </nav>
</div>
